import React, { Component } from 'react';
import moment from 'moment';
import Config from '../Config';
import './css/summary.css'

class VisitHistory extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: "",
            previousSaves: []
        };
    }

    componentDidMount() {
        // load the existing images
        this.initPictures(this.props.cardCode);
    }

    initPictures(cardCode) {
        // retrieve previous pictures and remarks
        const requestOptions = Config.GetBearer();
        fetch(Config.DigibonServiceBase + 'businesspartner/' + cardCode + '/pictures', requestOptions)
            .then(response => {
                return response.ok ? response.json() : { status: response.status }
            })
            .then(data => {
                if (data.status === 401) {
                    alert("Het is noodzakelijk opnieuw in te loggen");
                    return;
                }
                // show the already existing pictures + the new pictures
                this.setState({ previousSaves: data });
            })
    }

    GetExistingImageSource(item) {
        return Config.DigibonServiceBase + "picture/" + item.id;
    }
    
    selectPicture(picture) {
        this.setState({ mode: "fotoview", selectedPicture: picture });
    }

    closeFotoView() {
        this.setState({ mode: "" });
    }

    deletePicture() {
        this.setState({ mode: "confirmDelete" });
    }

    deletePictureConfirmed() {
        var pictures = this.state.pictures;
        var itemToRemove = this.state.selectedPicture;

        if (itemToRemove.id) {
            // remove existing picture
            const requestOptions = Config.GetBearerDelete();
            fetch(Config.DigibonServiceBase + 'picture/' + itemToRemove.id, requestOptions)
                .then(response => {
                    if (response.ok) {
                        this.setState({ mode: "" });
                        this.initPictures(this.props.cardCode);
                    }
                })
        } else {
            // remove the "added" but not yet saved picture
            pictures = pictures.filter(p => p.data !== itemToRemove.data);
            this.setState({ pictures: pictures, mode: "" });

            // update the parent
            var deleteAtIndex = this.props.changes.pictures.find(p => p.data === itemToRemove.data);
            this.props.changes.pictures.splice(deleteAtIndex, 1)
        }
    }
    getTechnicianName(changes) {
        var name=changes.technicianName;
        if (!name) {
            var t=Config.Technicians.find(p=>p.code===changes.technicianCode);
            if (t) name=t.name;
        }
        return name + " (" + changes.technicianCode + ")";
    }

    render() {

        return <React.Fragment>
            {this.state.mode === "" &&
                <div>
                    {this.state.previousSaves && this.state.previousSaves.map((item, index) => {
                        return <fieldset key={index}>
                            <legend>{moment(item.processes[0].processedDate).format('DD-MM-YYYY HH:mm')}</legend>
                            <div>
                                {item.pictures && item.pictures.map((picture, idx) => {
                                    return <div className="thumbnail img-container" key={idx}>
                                        <img src={this.GetExistingImageSource(picture)} alt={"webcam image " + idx} onClick={() => this.selectPicture(picture)} />
                                    </div>
                                })
                                }
                            </div>
                            <div className="clearfix"></div>
                            <div>{item.processes[0].changes.processRemark}</div>
                            <div>Monteur: <i>{this.getTechnicianName(item.processes[0].changes)}</i></div>

                        </fieldset>
                    }
                    )}
                </div>
            }
            {this.state.mode === "fotoview" && <div>
                <div className="picture-back"></div>

                <div className="picture-front">
                    <div className="mb-2 row">
                        <div className="col">

                            <img src={this.state.selectedPicture.id ?
                                this.GetExistingImageSource(this.state.selectedPicture) :
                                this.state.selectedPicture.data} alt="zoomed"></img>
                        </div>
                    </div>

                    <button className="sticky-top btn btn-secondary mb-4 position-absolute top-0 end-0 mt-2 me-2" onClick={this.closeFotoView.bind(this)}>terug</button>

                    <button className="btn btn-danger ms-2" onClick={this.deletePicture.bind(this)}>verwijder</button>
                </div>
            </div>
            }

            {this.state.mode === "confirmDelete" &&
                <div>
                    <div className="message-back"></div>

                    <div className="message-front">
                        <p>Plaatje verwijderen ?</p>

                        <button className="btn btn-secondary" onClick={p => this.setState({ mode: "" })}>annuleren</button>
                        <button className="ms-2 btn btn-primary" onClick={p => this.deletePictureConfirmed()}>bevestigen</button>
                    </div>
                </div>
            }
        </React.Fragment>
    }
}

export default VisitHistory;